import PropTypes from 'prop-types'
import React from 'react'

import LinkBlockArrowShort from 'components/LinkBlockArrowShort'

import { AddressLink, Line, Title, Wrapper } from './styles'

const AddressLine = ({ link, title, value }) => (
  <Wrapper>
    <LinkBlockArrowShort
      to={link}
      as="a"
      className="link--inverted"
      isWhite={true}
    >
      <AddressLink>
        <Title
          isHiddenOnMob={true}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <Line />
        <Title dangerouslySetInnerHTML={{ __html: value }} />
      </AddressLink>
    </LinkBlockArrowShort>
  </Wrapper>
)

AddressLine.propTypes = {
  link: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.string,
}

AddressLine.defaultProps = {
  link: '',
  title: '',
  value: '',
}

export default AddressLine
